const USER_DATA_KEY = "userData";
const TOKEN_KEY = "VendorToken";
const BOT_DATA_KEY = "botData";

export const getVendorToken = () => sessionStorage.getItem(TOKEN_KEY);

// Decode a JWT payload without verifying the signature. Client-side only — used
// to avoid opening a WebSocket (or firing a request) with an already-dead token.
export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded));
  } catch (_error) {
    return null;
  }
};

// True only when we can prove the token is past its `exp`. An unknown or
// unparseable token returns false (fail open) — callers that open sockets cap
// their own retries, so we never want to falsely lock out a valid session.
export const isTokenExpired = (token = getVendorToken()) => {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;
  return payload.exp * 1000 <= Date.now();
};

export const getStoredBot = () => {
  try {
    return JSON.parse(sessionStorage.getItem(BOT_DATA_KEY) || "null");
  } catch (_error) {
    return null;
  }
};

export const updateStoredBot = (patch = {}) => {
  const currentBot = getStoredBot();
  if (!currentBot) return null;
  const nextBot = { ...currentBot, ...patch };
  sessionStorage.setItem(BOT_DATA_KEY, JSON.stringify(nextBot));
  return nextBot;
};

export const getStoredUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem(USER_DATA_KEY) || "{}");
  } catch (_error) {
    return {};
  }
};

export const getAccountStatus = (user = getStoredUser()) => {
  if (user?.account_status) return user.account_status;
  return user?.is_active === false ? "pending" : "active";
};

export const isPendingVendorSession = (user = getStoredUser()) =>
  getAccountStatus(user) === "pending" || user?.approval_required === true;

export const storeAdminSession = (responseData = {}) => {
  const currentUser = getStoredUser();
  const token = responseData.access_token || responseData.token;
  const nextUser = {
    ...currentUser,
    ...responseData,
  };

  if (!nextUser.account_status && nextUser.is_active === false) {
    nextUser.account_status = "pending";
  }

  delete nextUser.access_token;
  delete nextUser.token;

  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  if (nextUser.user_id) sessionStorage.setItem("vendor_id", nextUser.user_id);
  sessionStorage.setItem(USER_DATA_KEY, JSON.stringify(nextUser));
  sessionStorage.setItem("isAdmin", String(nextUser.type?.includes("ADMIN") || false));

  return nextUser;
};

export const clearAdminSession = () => {
  [TOKEN_KEY, USER_DATA_KEY, "vendor_id", "isAdmin", "botData"].forEach((key) =>
    sessionStorage.removeItem(key)
  );
};
